'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useSession } from 'next-auth/react';
import { type ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';
import { AuthenticationButton } from '@module/mdrt-org/shared/components/authentication-button/authentication-button';
import { NotificationsDropdown } from '@module/mdrt-org/shared/components/header/components/notifications/notifications-dropdown/notifications-dropdown';
import { type HeaderAccountDropdownContent } from '@module/mdrt-org/shared/components/header/graphql/get-header-profile-dropdown-content';
import { Link } from '@module/mdrt-org/shared/i18n/i18n-navigation-link';
import { MdrtFullLogo } from '@shared/ui-components/svgs';
import { HOMEPAGE_PATH } from '../../../../utils/constants/local-paths';
import { type LanguagesContent } from '../../../../utils/hooks/get-languages-content-cached';
import { type NavigationItem } from '../../../../utils/types/navigation-items';
import { LanguageSwitcher } from '../../../language-switcher/language-switcher';
import { useGlobalCmsContentContext } from '../../../providers/global-cms-context';
import { Navigation } from '../navigation/navigation';
import styles from './header-content.module.scss';
type HeaderContentProps = {
  isSecondaryTheme: boolean;
  languagesCmsContent: LanguagesContent;
  locale: string;
  navigationItems: NavigationItem[];
  profileDropdownCmsContent: HeaderAccountDropdownContent;
  profileDropdownSlot: ReactNode;
  statusChipSlot: ReactNode;
};
export const HeaderContent = t0 => {
  const $ = _c(35);
  const {
    isSecondaryTheme,
    languagesCmsContent,
    locale,
    navigationItems,
    profileDropdownCmsContent,
    profileDropdownSlot,
    statusChipSlot
  } = t0;
  const session = useSession();
  const isSessionLoading = session.status === "loading";
  const isAuthenticated = session.status === "authenticated";
  const {
    cmsContent: globalCmsContent
  } = useGlobalCmsContentContext();
  let t1;
  if ($[0] !== isSecondaryTheme) {
    t1 = classNames(styles["header-content"], {
      [styles["header-content--secondary"]]: isSecondaryTheme
    });
    $[0] = isSecondaryTheme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MdrtFullLogo className={styles["header-content__logo"]} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== globalCmsContent.goBackToHomePageLabel) {
    t3 = <Link aria-label={globalCmsContent.goBackToHomePageLabel} data-testid="mdrt-logo-button" href={HOMEPAGE_PATH}>{t2}</Link>;
    $[3] = globalCmsContent.goBackToHomePageLabel;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isAuthenticated || $[6] !== isSecondaryTheme || $[7] !== languagesCmsContent || $[8] !== navigationItems || $[9] !== profileDropdownCmsContent) {
    t4 = <Navigation isAuthenticated={isAuthenticated} isSecondaryTheme={isSecondaryTheme} languagesCmsContent={languagesCmsContent} navigationItems={navigationItems} profileDropdownCmsContent={profileDropdownCmsContent} />;
    $[5] = isAuthenticated;
    $[6] = isSecondaryTheme;
    $[7] = languagesCmsContent;
    $[8] = navigationItems;
    $[9] = profileDropdownCmsContent;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = isSessionLoading ? null : isAuthenticated && statusChipSlot;
  let t6;
  if ($[11] !== languagesCmsContent.languagesList || $[12] !== locale || $[13] !== profileDropdownCmsContent.selectLanguageLabel) {
    t6 = <LanguageSwitcher languagesList={languagesCmsContent.languagesList} locale={locale} selectLanguageLabel={profileDropdownCmsContent.selectLanguageLabel} />;
    $[11] = languagesCmsContent.languagesList;
    $[12] = locale;
    $[13] = profileDropdownCmsContent.selectLanguageLabel;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isSessionLoading) {
    t7 = isSessionLoading && <Skeleton height={20} style={{
      opacity: "0.5"
    }} width={80} />;
    $[15] = isSessionLoading;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== isAuthenticated || $[18] !== isSessionLoading) {
    t8 = isSessionLoading ? null : isAuthenticated && <NotificationsDropdown />;
    $[17] = isAuthenticated;
    $[18] = isSessionLoading;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== isAuthenticated || $[21] !== isSessionLoading || $[22] !== profileDropdownSlot) {
    t9 = isSessionLoading ? null : isAuthenticated ? profileDropdownSlot : <AuthenticationButton isAuthenticated={isAuthenticated} />;
    $[20] = isAuthenticated;
    $[21] = isSessionLoading;
    $[22] = profileDropdownSlot;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t10 = <div className={styles["header-content__controls"]}>{t5}{t6}{t7}{t8}{t9}</div>;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t1 || $[31] !== t10 || $[32] !== t3 || $[33] !== t4) {
    t11 = <div className={t1}>{t3}{t4}{t10}</div>;
    $[30] = t1;
    $[31] = t10;
    $[32] = t3;
    $[33] = t4;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  return t11;
};